import React from "react";
import { blogData } from "../../thirdUtils/constant";
import { MdAccessTimeFilled } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";

const HomeBlog = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div className="third-design-home-blog-main">
            {
                blogData?.map((v, i) => {
                    return (
                        <div data-aos="fade-up"
                            data-aos-easing="ease-out-cubic"
                            data-aos-delay="100"
                            data-aos-offset="0"
                            data-aos-duration="1500">
                            <div className="third-design-home-blog-img-div">
                                <img src={v?.img} alt="" />
                            </div>
                            <div className="third-design-home-blog-text-div">
                                <h2>
                                    {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                </h2>
                                <span><MdAccessTimeFilled />
                                    {isELSelect ? v?.date : (isAlSelect ? v?.alDate : v?.glDate)}
                                </span>
                                <p>
                                    {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                </p>
                                <button>{selectedLanguage?.txt_learn_more} <FaArrowRight /></button>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default HomeBlog